import { getOperationCost } from '@habity/services';
import { NestedHome } from '@habity/types';
import { HomeDataBuilder } from './data-builder';
import { operatingCostsFields } from './operatingCosts-fields';

export const getOperatingCostsDescription = (home: NestedHome) => {
  const { provider_data } = home || {};

  const { operation } = provider_data || {};
  const { sum } = operation || {};
  return sum ? getOperationCost(sum) : null;
};

export const getOperatingCostsData = (home: NestedHome) => {
  return new HomeDataBuilder(home)
    .addFields(operatingCostsFields)
    .build();
};
